import BCComponent from "./bc_component";
import {bindActionCreators} from "redux";
import {getBonusTasks, submitBonusTask} from "game/app/actions/bonus-tasks-actions";
import connect from "react-redux/es/connect/connect";
import React from "react";

class Oblast2 extends BCComponent {

    render() {
        return (
            <div>
                <h3>Oblast 2 – PSANÉ SLOVO (články, knížky ...)</h3>
                <div className='separate-bottom'>
                    <p>Pokud chcete proniknout hlouběji do nějakého tématu nebo znát názor odborníků na určité téma, dobrý zdrojem inspirace a informací jsou <b>odborné články</b>. Ty je nejlepší hledat na odborných webových portálech nebo v médiích.</p>
                    <p>Rozsáhlejší texty pak najdete <b>v knížkách</b> a dalších publikacích.</p>
                    <p>Četba knih je od vynálezu knihtisku základním zdrojem informací. Při četbě navíc rozvíjíme naše myšlení a fantazii a posilujeme vyjadřovací schopnosti. Knihy mohou být různého typu - některé jsou jen pro zábavu, některé slouží pro osobní rozvoj či vzdělávání. Pro tyto účely je nejlepší vyhledávat knihy odborné.</p>
                </div>

                <h4>Znalostní úkoly</h4>
                { this.showTask('psane_slovo_1') }
                {/* { this.showTask('psane_slovo_5') } */}
                <br/>

                <h4>Tvořivé úkoly</h4>
                { this.showTask('psane_slovo_2') }
                { this.showTask('psane_slovo_3') }

                <p><i>Můžete poslat větší množství výtvorů a recenzí, započítáno však bude max. 50 chechtáků.</i></p>
                <br/>

                <h4>Otázky pro dospěláka</h4>
                { this.showTask('psane_slovo_4') }

                <p><i>Pozn. Přispět týmu můžete také tím, že mu pomůžete napsat recenze na knížky.</i></p>

            </div>
        );
    }
}

function mapStateToProps(state,ownProps) {
    return {
        bonusTasks: state.bonusTasks,
        gameInstance: state.gameInstance
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        getBonusTasks: getBonusTasks,
        submitBonusTask: submitBonusTask
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Oblast2);
